export default "__VITE_ASSET__s5tjoXrm__"